<template>
  <div class='menu'>
    <div v-if="sure" class="fl1 loads">
      <div class="xql"><van-loading size="26px" color="#fff" type="spinner" vertical>加载中...</van-loading></div>
    </div>
    <div class="p01" v-show="dataList">
      <!-- <van-swipe :autoplay="3000" :show-indicators="false">
                <van-swipe-item v-for="(image, index) in images" :key="index">
                    <img v-lazy="image" />
                </van-swipe-item>
            </van-swipe> -->
      <!-- <img src="../../assets/index/tu.png" style="width: 100%;" @click="goBanner('/ser')"> -->
      <img src="../../assets/index/tu2.png" style="width: 100%;" @click="goBanner('/ser')">
      <!-- AI商家助手入口 -->
      <div class="ai_banner" @click="goAi()" v-if="aiShow">
        <div class="ai_banner_deco ai_banner_deco1"></div>
        <div class="ai_banner_deco ai_banner_deco2"></div>
        <div class="ai_banner_left">
          <div class="ai_banner_title">
            <svg viewBox="0 0 24 24" width="17" height="17" fill="none" class="ai_banner_sparkle">
              <path d="M12 2l1.9 5.6L20 9.4l-5 3.9 1.5 6-4.5-3.4L7.5 19.3 9 13.3 4 9.4l6.1-1.8L12 2z" fill="#fff" />
            </svg>
            AI商家助手
          </div>
          <div class="ai_banner_sub">智能问答 · 经营分析 · 24小时在线</div>
          <div class="ai_banner_btn">立即体验</div>
        </div>
        <div class="ai_banner_robot">
          <svg viewBox="0 0 64 64" width="62" height="62" fill="none">
            <rect x="10" y="18" width="44" height="34" rx="10" fill="rgba(255,255,255,.22)" />
            <rect x="14" y="22" width="36" height="26" rx="7" fill="#fff" />
            <circle cx="25" cy="33" r="3.5" fill="#1260FC" />
            <circle cx="39" cy="33" r="3.5" fill="#1260FC" />
            <path d="M25 42c2.3 2 4.6 3 7 3s4.7-1 7-3" stroke="#1260FC" stroke-width="2.4" stroke-linecap="round" />
            <path d="M32 18v-7" stroke="#fff" stroke-width="3" stroke-linecap="round" />
            <circle cx="32" cy="8" r="3.4" fill="#fff" />
            <path d="M10 32H6c-1.7 0-3 1.3-3 3v4c0 1.7 1.3 3 3 3h4M54 32h4c1.7 0 3 1.3 3 3v4c0 1.7-1.3 3-3 3h-4" stroke="rgba(255,255,255,.65)" stroke-width="3"
              stroke-linecap="round" />
          </svg>
        </div>
      </div>
      <div class="caozuo">
        <p>常用功能</p>
        <ul>
          <li :class="dataList[item.key] == 1 ? '' : 'none'" @click="goVillage(index)" v-for="(item, index) in list" :key="index">
            <div class="flm"><img :src="item.url" class="Img"></div>
            <div>{{ item.data }}</div>
          </li>
        </ul>
      </div>
      <div class="caozuo" v-if="arrShow">
        <p>财务管理</p>
        <ul>
          <li :class="dataList[item.key] == 1 ? '' : 'none'" @click="goVillages(index)" v-for="(item, index) in arrList" :key="index">
            <div class="flm"><img :src="item.url" class="Img"></div>
            <div>{{ item.data }}</div>
          </li>
        </ul>
      </div>
      <div class="gongju" v-if="shi">
        <p>常用工具</p>
        <ul>
          <li :class="dataList[item.key] == 1 ? '' : 'none'" @click="goVillage1(index)" v-for="(item, index) in list1" :key="index">
            <div class="badge" v-if="repair_request_num && item.key=='repair_service'">{{repair_request_num<99?repair_request_num:99}}
            </div>
            <div class="flm"><img :src="item.url" class="Img"></div>
            <div>{{ item.data }}</div>
          </li>
        </ul>
      </div>
      <div class="xiaoxi" v-if="shis">
        <p>消息管理</p>
        <ul>
          <li :class="dataList[item.key] == 1 ? '' : 'none'" @click="goVillage2(index)" v-for="(item, index) in list2" :key="index">
            <div class="flm"><img :src="item.url" class="Img"></div>
            <div>{{ item.data }}</div>
          </li>
        </ul>
      </div>
      <div class="xiaoxi">
        <p>系统管理</p>
        <ul>
          <li @click="goJj()" v-if="ada == 1">
            <img src="../../assets/cd/sj.png" class="Img">
            <div>商户进件</div>
          </li>
          <li @click="goHome()" v-if="old == 1">
            <img src="../../assets/cd/old.png" class="Img">
            <div>版本切换</div>
          </li>
          <li @click="goMy()">
            <img src="../../assets/cd/my1.png" class="Img">
            <div>个人中心</div>
          </li>
        </ul>
      </div>
    </div>
    <div style="height: 6rem;"></div>
    <img src="../../assets/kf.png" id="floating-img" ref="floatingImg" @click="kfs()">
    <div class="title" v-if="surveyAlert == 1" @click.self="surveyAlert = 0">
      <div class="titleDiv">
        <img src="../../assets/kxm.png" style="position: absolute;right: -1.4rem;top: -3.6rem;width: 9rem;">
        <img src="../../assets/del.png" style="position: absolute;right: 0;top: -6.8rem;width: 2.6rem;" @click="surveyAlert = 0">
        <div style="text-align: center;">
          <img src="../../assets/text.png" alt="" style="width: 16.8rem;">
        </div>
        <p class="titleP">
          兴科的发展离不开您的支持<br>兴科邀请您进行2025年满意度调查! </p>
        <div>
          <button @click="toUrl()">
            <div class="fl1">
              <img src="../../assets/edit.png" style="width: 1.5rem;margin-right: .2rem;">立即填写
            </div>
          </button>
        </div>
        <div class="text1" @click="close()">残忍拒绝</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getMenu } from '@/api/menu'
  import bus from "../../store/bus"
  import wx from 'weixin-js-sdk'
  import { getInlet, venderSurveySave } from "../../api/index"
  export default {
    components: {},
    data() {
      return {
        images: [],
        bannerUrl: '',
        bs_link: '',
        dataList: [],
        ada: 0,
        repair_request_num: 0,
        surveyAlert: 0,
        adaType: '',
        qr: '',
        link: [],
        aiShow: 0,
        sure: false,
        shi: false,
        arrShow: false,
        shis: false,
        tab: false,
        old: '',
        a: null,
        url: null,
        worktable: '',
        list: [{
          url: require('../../assets/cd/xiaoqu2.png'),
          data: "小区管理",
          key: 'district_check',
          path: '/village'
        }, {
          url: require('../../assets/cd/dingdan2.png'),
          data: "订单管理",
          key: 'order_check',
          path: '/order'
        }, {
          url: require('../../assets/cd/sbjl2.png'),
          data: "设备管理",
          key: 'dev_check',
          path: '/device'
        }, {
          url: require('../../assets/cd/yonghu2.png'),
          data: "用户管理",
          key: 'user_check',
          path: '/user'
        }, {
          url: require('../../assets/cd/dianka2.png'),
          data: "电卡管理",
          key: 'card_check',
          path: '/elecard'
        }, {
          url: require('../../assets/cd/lxian.png'),
          data: "离线设备",
          key: 'dev_offline_check',
          path: '/leave'
        }],
        arrList: [{
          url: require('../../assets/cd/liuliang2.png'),
          data: "流量卡管理",
          key: 'iccid_check',
          path: '/traffic'
        }, {
          url: require('../../assets/cd/yunying2.png'),
          data: "数据统计",
          key: 'statistic_check',
          path: '/operate'
        }, {
          url: require('../../assets/cd/zengzhi2.png'),
          data: "增值收入",
          key: 'advert_check',
          path: '/gain'
        }, {
          url: require('../../assets/cd/tuikuan2.png'),
          data: "线上退款",
          key: 'withdraw_check',
          path: '/ref'
        }, {
          //     url: require('../../assets/cd/yuancheng2.png'),
          //     data: "远程控制",
          // },{
          //     url: require('../../assets/cd/chaobiao2.png'),
          //     data: "抄表管理",
          // },{
          url: require('../../assets/cd/tx.png'),
          data: "提现管理",
          key: 'switch_check',
          path: '/intos'
        }, {
          url: require('../../assets/cd/fc.png'),
          data: "分成管理",
          key: 'meter_check',
          path: '/into'
        }, {
          url: require('../../assets/cd/ledger.png'),
          data: "项目台账",
          key: 'ledger_check',
          path: '/ledger'
        }],
        list1: [{
            url: require('../../assets/cd/saoma2.png'),
            data: "扫码组网",
            key: 'join_check',
          }, {
            url: require('../../assets/cd/socx.png'),
            data: "网关信道",
            key: 'tool_ct',
            path: '/channel'
          }, {
            url: require('../../assets/cd/zduan2.png'),
            data: "终端修改",
            key: 'ct_set_check',
            path: '/terset'
          }, {
            url: require('../../assets/cd/qr.png'),
            data: "二维码修改",
            key: 'ct_qrcode_check'
          }, {
            url: require('../../assets/cd/zduan2.png'),
            data: "终端查询",
            key: 'socket_check',
            path: '/terminal'
          }, {
            url: require('../../assets/cd/shebei2.png'),
            data: "设备分配",
            key: 'assign_check',
          }, {
            url: require('../../assets/cd/wx.png'),
            data: "维护人员",
            key: 'tool_user_check',
            path: '/main'
          }, {
            url: require('../../assets/cd/mm.png'),
            data: "运维协助",
            key: 'remote_support',
            path: '/mm'
          }, {
            url: require('../../assets/cd/slbx.png'),
            data: "手录报修",
            key: 'dev_service',
            path: '/repair',
          },
          {
            url: require('../../assets/cd/yhbx.png'),
            data: "用户报修",
            key: 'repair_service',
            path: '/repairRecord',
          },
        ],
        list2: [{
          url: require('../../assets/cd/yichang2.png'),
          data: "异常警告",
          key: 'alarm_check',
          path: '/alarm'
        }, {
          url: require('../../assets/cd/xitong2.png'),
          data: "系统信息",
          key: 'msg_check',
        }, {
          url: require('../../assets/cd/baoxiu2.png'),
          data: "保修工单",
          key: 'work_check',
        }]
      };
    },
    methods: {
      goVillage(k) {
        this.$router.push({
          path: this.list[k].path
        })
      },
      goVillages(k) {
        this.$router.push({
          path: this.arrList[k].path
        })
      },
      close() {
        venderSurveySave({ token: localStorage.getItem('token') }).then(res => {
          if (res.data.code == 1) {
            this.surveyAlert = 0;
          }
        })
      },
      goVillage1(k) {
        if (this.list1[k].data == '二维码修改') {
          wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              wx.miniProgram.navigateTo({
                url: '/pages/qrcode/index?token=' + localStorage.getItem('token')
              });
            }
          })
        } else if (!this.list1[k].path) {
          window.location.href = this.link[this.list1[k].key];
        } else {
          this.$router.push({
            path: this.list1[k].path
          })
        }
      },
      goVillage2(k) {
        this.$router.push({
          path: this.list2[k].path
        })
      },
      goMy() {
        this.$router.push({
          path: '/my'
        })
      },
      goAi() {
        this.$router.push({
          path: '/aiChat'
        })
      },
      goJj() {
        if (this.adaType == 'bspay') {
          // 跳转
          window.location.href = this.bs_link;
        } else {
          this.$router.push({
            path: '/info'
          })
        }
      },
      toUrl() {
        window.open(this.qr);
      },
      urlTo(path) {
        this.$router.push({
          path: path
        })
      },
      phone() {
        this.$router.push({
          path: '/play'
        })
      },
      // 菜单权限
      async menu() {
        this.sure = true;
        let data = await getMenu({ token: localStorage.getItem('token') });
        if (data.data.code == 1) {
          this.repair_request_num = Number(data.data.data.check.repair_request_num || 0)
          this.dataList = data.data.data.check;
          this.aiShow = data.data.data.check.ai_show || 0;
          this.link = data.data.data.link;
          this.bs_link = data.data.data.bs_link;
          this.url = data.data.data.old_link;
          this.old = data.data.data.old_link_check;
          this.bannerUrl = data.data.data.ada_confirm;
          for (let index = 0; index < this.list1.length; index++) {
            if (this.dataList[this.list1[index].key] == 1) { this.shi = true; }
          }
          for (let index = 0; index < this.list2.length; index++) {
            if (this.dataList[this.list2[index].key] == 1) { this.shis = true; }
          }
          for (let index = 0; index < this.arrList.length; index++) {
            if (this.dataList[this.arrList[index].key] == 1) { this.arrShow = true; }
          }
        }
        this.sure = false;
        let data1 = await getInlet({ token: localStorage.getItem("token") });
        if (data1.data.code == 1) {
          this.worktable = data1.data.data.check_worktable;
          // this.alert = data1.data.data.check_alert;
          this.surveyAlert = data1.data.data.survey_alert;
          this.qr = data1.data.data.survey_url;
          this.ada = data1.data.data.check_ada;
          this.adaType = data1.data.data.ada_mch_type;

          bus.$emit("worktable", this.worktable);
        }
      },
      goBanner() {
        // window.location.href = this.bannerUrl
        window.location.href = `https://jav.xkmip.cn/ali/v1/h5/pages/activeIndex/index.html?source=1`
      },
      goHome() {
        window.location.href = this.url;
      },
      kfs() {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            wx.miniProgram.navigateTo({
              url: '/pages/service/index?token=' + localStorage.getItem('token')
            });
            return;
          }
        })
      }
    },
    created() {
      this.menu();
      const currentUrl = window.location.href;
      if (currentUrl.includes('/?key=')) {
        const newUrl = 'https://vender.xingkeele.com/#/menu';
        history.pushState(null, null, newUrl);
      }
    },
    mounted() {
      const floatingImg = this.$refs.floatingImg;
      if (!floatingImg) return;
      floatingImg.style.right = '1rem';
      floatingImg.style.transition = 'right 0.6s ease';
      let scrollTimeout;
      const hideDelay = 300;
      const handleScroll = () => {
        floatingImg.style.right = '-5rem';
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          floatingImg.style.right = '1rem';
        }, hideDelay);
      };
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      });
    }
  }
</script>
<style lang="less">
  .menu {
    min-height: 100%;
    background-color: #f2f3f5;

    .title {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: inherit;

      button {
        width: 18rem;
        border-radius: 36px;
        background: linear-gradient(90deg, rgba(18, 96, 252, 1) 0%, rgba(38, 176, 255, 1) 100%);
        display: flex;
        justify-content: center;
        align-items: center;
        height: 4.8rem;
        margin: 0 auto;
        color: #fff;
        font-size: 1.6rem;
        margin-bottom: 1.6rem;
      }

      .titleDiv {
        background: url('../../assets/menuBg.png') 0 0 no-repeat;
        background-size: 100% 100%;
        width: 25.6rem;
        position: relative;
        padding: 2.5rem 2.8rem 2.2rem 2.6rem;
      }

      .titleP {
        text-align: center;
        margin: 3rem 0;
        font-size: 1.6rem;
        line-height: 2.4rem;
      }

      .text1 {
        font-size: 1.4rem;
        color: rgba(85, 92, 105, 1);
        text-align: center;
      }
    }

    #floating-img {
      position: fixed;
      bottom: 10rem;
      width: 6rem;
    }

    /* AI商家助手入口 banner */
    .ai_banner {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: .8rem;
      padding: 1.6rem 1.6rem;
      border-radius: 1rem;
      background: linear-gradient(135deg, #1260FC 0%, #26B0FF 100%);
      box-shadow: 0 .4rem 1.6rem rgba(18, 96, 252, .28);
      overflow: hidden;

      &:active {
        opacity: .92;
      }

      .ai_banner_deco {
        position: absolute;
        border-radius: 50%;
        background: rgba(255, 255, 255, .1);
      }

      .ai_banner_deco1 {
        width: 10rem;
        height: 10rem;
        right: -3rem;
        top: -4.5rem;
      }

      .ai_banner_deco2 {
        width: 6rem;
        height: 6rem;
        left: 38%;
        bottom: -3.5rem;
      }

      .ai_banner_left {
        position: relative;
        z-index: 2;
        text-align: left;
      }

      .ai_banner_title {
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 1.7rem;
        font-weight: 600;
        letter-spacing: .05rem;

        .ai_banner_sparkle {
          margin-right: .5rem;
        }
      }

      .ai_banner_sub {
        margin-top: .5rem;
        color: rgba(255, 255, 255, .85);
        font-size: 1.15rem;
      }

      .ai_banner_btn {
        display: inline-block;
        margin-top: 1rem;
        padding: .45rem 1.4rem;
        border-radius: 1.6rem;
        background: #fff;
        color: #1260FC;
        font-size: 1.2rem;
        font-weight: 600;
        box-shadow: 0 .2rem .8rem rgba(0, 0, 0, .12);
      }

      .ai_banner_robot {
        position: relative;
        z-index: 2;
        flex-shrink: 0;
        margin-left: 1rem;
      }
    }

    .p01 {
      padding: 0 1rem;
      margin-top: 1rem;
    }

    .oLi {
      display: block;

    }

    .Img {
      width: 4rem;
      height: 4rem;
    }

    .flm {
      display: flex;
      justify-content: center;
      margin-bottom: .6rem;
    }

    .caozuo,
    .gongju,
    .xiaoxi {
      height: auto;
      background-color: #fff;
      border-radius: .6rem;
      padding: 1.5rem 1.2rem 0;
      margin-top: .8rem;
    }

    .gongju,
    .xiaoxi,
    .caozuo {
      p {
        margin-left: .4rem;
        font-weight: 600;
        font-size: 1.6rem;
      }

      ul {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin: 1rem 0 0;

        li {
          width: 25%;
          font-size: 1.5rem;
          margin-bottom: 1.5rem;
          text-align: center;
          position: relative;
        }
      }
    }

    .none {
      display: none !important;
    }
  }

  .badge {
    width: 2rem;
    height: 2rem;
    opacity: 1;
    background: rgba(242, 87, 87, 1);
    border: 1px solid rgba(255, 255, 255, 1);
    border-radius: 50%;
    font-size: 1.2rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: .8rem;
    top: -.8rem;
    z-index: 15;
  }
</style>